// Single source of truth for the business WhatsApp number, shared by the
// Footer link and the floating WhatsApp button so they never drift apart.
export const WHATSAPP_NUMBER = "96178751093";
export const WHATSAPP_DEFAULT_MESSAGE = "Hello Luma3D! I need support.";
